var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useCallback, useContext, useState } from 'react';
import DocumentComparisonsCommentsApi from '~/api/document_comparison_comments';
import { useUser } from '~/providers/user';
const CommentContext = createContext({});
const CommentProvider = (props) => {
    const [isLoadingComments, setIsLoadingComments] = useState(false);
    const [isPostingComment, setIsPostingComment] = useState(false);
    const [deletingCommentId, setDeletingCommentId] = useState(null);
    const [comments, setComments] = useState(null);
    const { name, privilegeGroups } = useUser();
    const addComment = useCallback((text, documentComparisonId, privilegeGroupIds, taggedUserIds) => __awaiter(void 0, void 0, void 0, function* () {
        if (!name)
            return;
        setIsPostingComment(true);
        const newComment = yield DocumentComparisonsCommentsApi.post({
            text,
            documentComparisonId,
            privilegeGroupIds,
            taggedUserIds,
        });
        newComment.createdBy = name;
        newComment.createdAt = new Date().toISOString().replace('Z', '');
        newComment.privilegeGroups = privilegeGroups.filter(p => privilegeGroupIds === null || privilegeGroupIds === void 0 ? void 0 : privilegeGroupIds.includes(p.id));
        setIsPostingComment(false);
        setComments([...(comments !== null && comments !== void 0 ? comments : []), newComment]);
    }), [comments, name, privilegeGroups]);
    const getComments = useCallback((id) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoadingComments(true);
        const comments = yield DocumentComparisonsCommentsApi.getById(id);
        setComments(comments);
        setIsLoadingComments(false);
    }), []);
    const deleteComment = (commentId) => __awaiter(void 0, void 0, void 0, function* () {
        setDeletingCommentId(commentId);
        yield DocumentComparisonsCommentsApi.deleteById(commentId);
        setComments([...(comments !== null && comments !== void 0 ? comments : []).filter(comment => comment.id !== commentId)]);
        setDeletingCommentId(null);
    });
    const value = {
        isLoadingComments,
        comments,
        deletingCommentId,
        isPostingComment,
        getComments,
        deleteComment,
        addComment,
    };
    return React.createElement(CommentContext.Provider, Object.assign({ value: value }, props));
};
const useComment = () => {
    const context = useContext(CommentContext);
    if (!context) {
        throw new Error('CommentContext must be used inside of a CommentProvider');
    }
    return context;
};
export { CommentProvider, useComment, };
